import { render, staticRenderFns } from "./warnings.vue?vue&type=template&id=303c0c9b&scoped=true&"
import script from "./warnings.vue?vue&type=script&lang=js&"
export * from "./warnings.vue?vue&type=script&lang=js&"
import style0 from "./warnings.vue?vue&type=style&index=0&id=303c0c9b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303c0c9b",
  null
  
)

export default component.exports